export default class Sound {
  static setCategory = () => {}
  static MAIN_BUNDLE = ""
  constructor(_filename: string, _basePath: string) {}
  play = () => {}
  stop = () => {}
  release = () => {}
}
